import { resolverPorcentajeAgencia } from "./resolverPorcentajeAgencia";
import { resolverPorcentajeApx } from "./resolverPorcentajeApx";
import { resolverPorcentajeBroker } from "./resolverPorcentajeBroker";

/**
 * Fuente ÚNICA de los 4 % de intermediación a congelar al facturar (Fase A2b, ver 7.22). Devuelve
 * `{ agencia, apx, broker, descuento }` con el % EFECTIVO que aplica el motor en vivo en `facturaDate`
 * (→ el congelado === el vivo en ese instante). No escribe nada; sólo resuelve.
 *
 * - `agencia`: `resolverPorcentajeAgencia` (post-ventana `comision_2`/directas). **Guarda de descuento
 *   (7.22): con `descuento_acuerdo_pct > 0` el % de agencia efectivo es 0** — el descuento reemplaza a
 *   la comisión de agencia (igual que la guarda del chokepoint), por eso OMNET congela agencia 0.
 * - `apx`: `resolverPorcentajeApx` (0 o 9, gate por `apx_id`).
 * - `broker`: `resolverPorcentajeBroker` (post-gate `comision_fechainicio` + `BROKER_ACTIVACION`).
 * - `descuento`: `descuento_acuerdo_pct` de la venta (estático).
 *
 * Para contrato-mes, `venta` es un objeto a nivel contrato (client_id/pais/apx_id/
 * descuento_acuerdo_pct) + la `facturafecha` del mes. `facturaDate` es un Date.
 */
export const resolverPctsCongelamiento = (venta, clientes, intermediarios, facturaDate) => {
  const descuento = parseFloat(venta?.descuento_acuerdo_pct) || 0;
  return {
    agencia: descuento > 0 ? 0 : resolverPorcentajeAgencia(venta, clientes, intermediarios, venta?.pais),
    apx: resolverPorcentajeApx(venta, intermediarios),
    broker: resolverPorcentajeBroker(venta, clientes, intermediarios, facturaDate),
    descuento,
  };
};
